var map = {
	"./content_bg.png": 740,
	"./icon01.png": 741,
	"./icon01_highlight.png": 742,
	"./icon02.png": 743,
	"./icon02_highlight.png": 744,
	"./icon03.png": 745,
	"./icon03_highlight.png": 746,
	"./icon04.png": 747,
	"./icon04_highlight.png": 748,
	"./icon05.png": 749,
	"./icon05_highlight.png": 750,
	"./left_bg.png": 751,
	"./middle_corner.png": 752
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2396;